import { Router } from '@angular/router';
import { CURRENT_CLAIM_NUMBER } from '@prcins/constants';
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
var ClaimNavigationService = /** @class */ (function () {
    function ClaimNavigationService(router) {
        this.router = router;
    }
    ClaimNavigationService.prototype.navigateToClaim = function (claimNumber, queryParams) {
        sessionStorage.setItem(CURRENT_CLAIM_NUMBER, claimNumber);
        this.router.navigate(['/eservice/home/claims'], { queryParams: queryParams });
    };
    ClaimNavigationService.prototype.canActivate = function () {
        this.router.navigate(['/eservice/home/claims/claimslist']);
        return false;
    };
    ClaimNavigationService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ClaimNavigationService_Factory() { return new ClaimNavigationService(i0.ɵɵinject(i1.Router)); }, token: ClaimNavigationService, providedIn: "root" });
    return ClaimNavigationService;
}());
export { ClaimNavigationService };
